import React from 'react';

import { useSelector } from 'react-redux';

import { actions } from 'coupon-common/src/modules/referrals/businesses';

import CommonList from './CommonList';

const BusinessesReferrals = () => {
  const businessesEntity = useSelector(state => state.referrals.businesses);

  return <CommonList getListAction={actions.getBusinessesList} stateEntity={businessesEntity} />;
};

export default BusinessesReferrals;